/*
 *
 * LeadersSummary reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_LEADERS_SUMMARY_WATCHER,
  GET_LEADERS_SUMMARY_SUCCESS,
  GET_LEADERS_SUMMARY_FAILED,
  SAVE_EXCEL_LEADERS_PROGRESS,
  SAVE_EXCEL_LEADERS_WATCHER,
} from "./constants"

export const initialState = fromJS({})

function ambassadorsSummaryReducer(state = initialState, action) {
  switch (action.type) {
    case SAVE_EXCEL_LEADERS_WATCHER:
      return state.set("percentage", 0)
    case SAVE_EXCEL_LEADERS_PROGRESS:
      return state.set("percentage", action.payload)

    case GET_LEADERS_SUMMARY_WATCHER:
      return state.set("isLoadingSummary", true).set("summary", [])
    case GET_LEADERS_SUMMARY_SUCCESS:
      return state.set("isLoadingSummary", false).set("summary", action.payload)
    case GET_LEADERS_SUMMARY_FAILED:
      return state.set("isLoadingSummary", false).set("summary", [])
    default:
      return state
  }
}

export default ambassadorsSummaryReducer
